import styleInject from '../../node_modules/style-inject/dist/style-inject.es.js';

var css_248z = ".flatSearchContainer .rbt-menu.dropdown-menu.show {\n  left: 0 !important;\n}\n.flatSearchContainer .right_aligned .rbt-menu.dropdown-menu.show {\n  left: unset !important;\n  right: 0 !important;\n}";
styleInject(css_248z);

export { css_248z as default };
//# sourceMappingURL=SearchFlat.scss.js.map
